/**
 * Jobs carry the full location trail entered against them
 * ("London, Greater London, South East, England"). Meta titles use only the first entry.
 *
 * @param location
 * @returns {string}
 */
export const getFirstLocation = (location = "") => String(location || "").split(",")[0].trim();
